import { LockOutlined } from "@ant-design/icons";
import { Typography } from "antd";
import "./AvailabilityOverflow.scss";

const { Text } = Typography;

interface AvailabilityOverflowProps {
  message?: string;
}

const AvailabilityOverflow = ({ 
  message = "Availability settings are not available" 
}: AvailabilityOverflowProps) => {
  return (
    <div className="availability-overflow">
      <div className="availability-overflow__content">
        <LockOutlined className="availability-overflow__icon" />
        <Text className="availability-overflow__text">
          {message}
        </Text>
      </div>
    </div>
  );
};

export default AvailabilityOverflow;
